












































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Fragment } from "vue-fragment";
import { NewReportStore } from "@/store/NewReportStore";
import Checkbox from "@/components/core/controls/checkbox.vue";
import lodash from "lodash";

@Component({
  components: {
    Fragment,
    Checkbox
  }
})
export default class ProductSearchModal extends Vue {
  @Prop() public products!: any[];
  @Prop() public alreadyAddedCustomers!: any[];
  @Prop() public addProducts!: (product: any, template: any, materialcertificate: any, heatNr: any, batch: any) => void;

  public templates: any[] = [];
  public allProducts: any[] = [];
  public filteredProducts: any[] = [];
  public selectedTemplate: any = null;
  public searchString: string = "";
  public materialCertificate: string = "";
  public heatNr: string = "";
  public batch: string = "";
  public showMultipleCustomersErrors = false;

  @Watch("products")
  public onProductsLoaded() {
    this.setup();
  }

  public mounted() {
    $("#products-search-modal").on("show.bs.modal", () => {
      this.onClose();
      this.setup();
    });
  }

  public onSearch() {
    if (this.searchString || this.selectedTemplate) {
      this.search();
    } else {
      this.applyFilter(this.allProducts);
    }
  }

  @Watch("searchString")
  public onSearchString() {
    this.onSearch();
  }

  @Watch("selectedTemplate")
  public onSearchTemplate() {
    this.onSearch();
  }

  public isNumber(event: KeyboardEvent) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      event.preventDefault();
    } else {
      return true;
    }
  }
  public onProductSelected(selectedProduct: any) {
    const product = this.allProducts.find(p => p.id === selectedProduct.id);
    product.isSelected = !product.isSelected;
  }

  public search() {
    const search = this.searchString
      .toString()
      .toLowerCase()
      .split(" ")
      .filter(s => s.length > 0);
    const products = this.allProducts.filter(product => {
      let isFound = false;

      if (this.alreadyAddedCustomers.length > 0) {
        if (!this.alreadyAddedCustomers.includes(product.customer)) {
          return false;
        }
      }

      if (product.description && search.length > 0 && this.selectedTemplate) {
        return lodash.every(
          search,
          searchString =>
            (product.description.toLowerCase().includes(searchString) ||
              product.articleNumber.toLowerCase().includes(searchString)) &&
            product.templates.filter(t => t.id === this.selectedTemplate.id).length > 0
        );
      } else if (product.description && search.length) {
        return lodash.every(
          search,
          searchString =>
            product.description.toLowerCase().includes(searchString) ||
            product.articleNumber.toLowerCase().includes(searchString)
        );
      } else if (this.selectedTemplate) {
        return product.templates.filter(t => t.id === this.selectedTemplate.id).length > 0;
      }

      return isFound;
    });
    console.log(products);
    this.filteredProducts = products;
  }

  public setup() {
    this.templates = [];
    const products = lodash.cloneDeep(this.products);
    products.forEach(p => {
      p.isSelected = false;
      p.templates.forEach((template: any) => {
        if (!this.templates.find(t => t.id === template.id)) {
          this.templates.push({
            ...template,
            value: template.id,
            label: template.name
          });
        }
      });
      p.numberOfSamples = 10;
      p.orderQuantity = "";
    });
    this.allProducts = products;
    this.applyFilter(products);
  }

  public onClose() {
    this.materialCertificate = "";
    this.heatNr = "";
    this.batch = "";
    this.allProducts.forEach(p => (p.isSelected = false));
    this.clear();

    // @ts-ignore
    $("#products-search-modal").modal("hide");
  }

  public clear() {
    this.searchString = "";
    this.selectedTemplate = null;
    this.showMultipleCustomersErrors = false;
  }

  public getTemplatesAsStringForProduct(product: any) {
    return product.templates
      .map((t, index) => {
        return t.name;
      })
      .join(", ");
  }

  public applyFilter(products: any[]) {
    this.filteredProducts = products.filter(p =>
      this.alreadyAddedCustomers.length > 0
        ? p.templates.length > 0 && this.alreadyAddedCustomers.includes(p.customer)
        : p.templates.length > 0
    );
  }

  public onAddProducts() {
    const selected = this.allProducts.filter(p => p.isSelected);
    const customers = lodash.uniq([...selected.map(s => s.customer), ...(this.alreadyAddedCustomers || [])]);

    if (customers.length > 1) {
      this.showMultipleCustomersErrors = true;
    } else {
      this.addProducts(selected, this.selectedTemplate, this.materialCertificate, this.heatNr, this.batch);
      this.onClose();
    }
  }
}
